import map from "../data/redirects.json";

const norm = (p) => (p.length > 1 ? p.replace(/\/+$/, "") : p) + "/";

export function resolveLegacyPath(pathname) {
  const raw = decodeURIComponent(pathname);
  const up = raw.match(/^\/wp-content\/uploads\/(.+)$/);
  if (up) return `/api/legacy/uploads/${up[1]}`;
  const path = norm(raw);
  if (map.pages[path]) return map.pages[path];
  let m = path.match(/^\/\d{4}\/\d{2}\/\d{2}\/([^/]+)\/$/) || path.match(/^\/blog\/([^/]+)\/$/);
  if (m) return map.posts[m[1]] ? `/services/${map.posts[m[1]]}` : "/";
  m = path.match(/^\/case-study\/([^/]+)\/$/);
  if (m) return map.cases[m[1]] ? `/services/${map.cases[m[1]]}` : "/publications";
  m = path.match(/^\/publication\/([^/]+)\/$/);
  if (m) return map.publications[m[1]] || "/publications";
  if (map.terms[path]) return map.terms[path];
  if (/^\/(category|tag|case-study-category|publication-category)\//.test(path)) return "/";
  if (/^\/\d{4}\/(\d{2}\/)?$/.test(path) || /^\/page\/\d+\/$/.test(path)) return "/";
  return null;
}

export function applyLegacyRedirect() {
  const target = resolveLegacyPath(window.location.pathname);
  if (target && target !== window.location.pathname) {
    const qs = window.location.search.replace(/^\?/, "");
    window.location.replace(qs ? target + (target.includes("?") ? "&" : "?") + qs : target);
    return true;
  }
  return false;
}
